import { InputAdornment, TextField } from '@mui/material';
import { FC, useRef, useState } from 'react';

interface PhoneProps {
  phoneNumber: string;
  label: string;
  disabled?: boolean;
  onChange: (phoneNumber: string, error: boolean, errorMessage: string) => void;
}

export const PhoneField: FC<PhoneProps> = ({ phoneNumber, onChange, label, disabled = false }) => {
  const formatPhoneNumber = (value: string) => {
    // Remove all non-digit characters
    const digits = value.replace(/\D/g, '');

    // Format the phone number as (XXX) XXX-XXXX
    if (digits.length <= 3) {
      return digits;
    } else if (digits.length <= 6) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    } else {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    }
  };

  const [newPhoneNumber, setNewPhoneNumber] = useState(formatPhoneNumber(phoneNumber));
  const [error, setError] = useState(false);
  const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const formattedNumber = formatPhoneNumber(event.target.value);
    setNewPhoneNumber(formattedNumber);
    onChange(formattedNumber, !isValidPhoneNumber(formattedNumber), 'Phone number invalid');
  };
  const inputRef = useRef<HTMLInputElement>(null);
  // Check if phone number is valid (10 digits)
  const isValidPhoneNumber = (formattedNumber: any) => {
    const digitsOnly = formattedNumber.replace(/\D/g, '');
    const isValid = digitsOnly.length === 10;
    setError(!isValid);
    return isValid;
  };
  // Format phone number as user types
  return (
    <>
      <TextField
        error={error}
        fullWidth
        disabled={disabled}
        label={label}
        variant="outlined"
        margin="normal"
        value={newPhoneNumber}
        onChange={handlePhoneChange}
        placeholder="(XXX) XXX-XXXX"
        helperText="Format: (XXX) XXX-XXXX"
        inputRef={inputRef}
        color={'primary'}
        slotProps={{
          input: { startAdornment: <InputAdornment position="start">+1</InputAdornment> },
        }}
      />
    </>
  );
};
